import React, { useEffect, useRef, useState, useContext } from 'react'
import HomeBakeryBackground from '../../assets/home-bakery-background.png'
import GoldenCrownRewardCard from '../../assets/golden_crown_reward_card.png'
import DefaultVoucher from "../../assets/default-voucher.png"
import { ThemeContext } from "../../context/ThemeContext"
import { AiOutlineHistory, AiOutlineGift, AiOutlineRight } from "react-icons/ai"
import { formatVoucherDiscount } from '../../utils/voucherDiscount'
import { BiStore } from "react-icons/bi"
import { Button, Card, Modal } from 'react-daisyui'
import ProfilUnknow from '../../assets/profile-unknown.png'
import { clearSession, session } from '../../utils/AuthSession'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import {
    AiOutlineCheckCircle,
    AiOutlineDelete,
    AiOutlineEdit,
    AiOutlineEnvironment,
    AiOutlineExclamationCircle,
    AiOutlineLoading3Quarters,
    AiOutlineLock,
    AiOutlineLogout,
    AiOutlineMail,
    AiOutlinePhone,
    AiOutlinePlus,
    AiOutlineSave,
    AiOutlineCamera,
    AiOutlineUser
} from 'react-icons/ai'
import { FaMapMarkerAlt } from 'react-icons/fa'
import Swal from 'sweetalert2'

const getAddressCoordinatePair = (addressData) => {
    const fromCoordinateString =
        typeof addressData?.coordinate === 'string'
            ? addressData.coordinate.split(',').map((value) => value.trim())
            : []

    if (fromCoordinateString.length === 2 && fromCoordinateString[0] && fromCoordinateString[1]) {
        return {
            latitude: fromCoordinateString[0],
            longitude: fromCoordinateString[1]
        }
    }

    return {
        latitude:
            addressData?.latitude ??
            addressData?.lat ??
            addressData?.address_latitude ??
            addressData?.coordinate_lat ??
            '',
        longitude:
            addressData?.longitude ??
            addressData?.lng ??
            addressData?.long ??
            addressData?.address_longitude ??
            addressData?.coordinate_lng ??
            ''
    }
}

const normalizeCoordinate = (value) => {
    if (value === null || value === undefined) return ''
    return String(value).trim()
}

function Profile() {
    const [profile, setProfile] = useState(null)
    const [profileImage, setProfileImage] = useState(null)
    const [address, setAddress] = useState([])
    const [profileForm, setProfileForm] = useState({
        firstname: '',
        lastname: '',
        image_profile: '',
        email: '',
        phone: ''
    })
    const [profileSaving, setProfileSaving] = useState(false)
    const [firstnameError, setFirstnameError] = useState('')
    const [contactLoading, setContactLoading] = useState('')
    const [contactCooldowns, setContactCooldowns] = useState({
        email: { seconds: 0, target: '' },
        phone: { seconds: 0, target: '' }
    })
    const [verification, setVerification] = useState({
        open: false,
        type: '',
        target: '',
        token: '',
        loading: false,
        error: '',
        message: '',
        messageType: '',
        cooldownSeconds: 0
    })
    const [photoUploading, setPhotoUploading] = useState(false)
    const fileInputRef = useRef(null)
    const cameraInputRef = useRef(null)
    const verificationInputRef = useRef(null)

    const navigate = useNavigate()

    const { primaryColor } = useContext(ThemeContext)
    const [authSession] = useState(session())

    const quickActions = [
        {
            id: 1,
            title: "Riwayat Transaksi point",
            subtitle: "Transaksi",
            icon: <AiOutlineHistory className="text-2xl" />,
            link: "/history",
            color: "from-blue-500 to-blue-600"
        },
        // {
        //     id: 2,
        //     title: "Merchant",
        //     subtitle: "Partner",
        //     icon: <BiStore className="text-2xl" />,
        //     link: "/merchant",
        //     color: "from-green-500 to-green-600"
        // }
    ]

    const memberName = profile?.firstname || authSession?.user?.firstname || authSession?.user?.phone || 'Member'
    const memberPoints = Number(profile?.point?.point) || 0


    useEffect(() => {
        initProfile()
        initAddress()
    }, [])

    useEffect(() => {
        if (verification.open) {
            setTimeout(() => verificationInputRef.current?.focus(), 100)
        }
    }, [verification.open])

    useEffect(() => {
        if (!verification.open) return

        const timer = setInterval(() => {
            setVerification((prev) => {
                if (!prev.open || !prev.cooldownSeconds) return prev

                return {
                    ...prev,
                    cooldownSeconds: Math.max(0, prev.cooldownSeconds - 1)
                }
            })
        }, 1000)

        return () => clearInterval(timer)
    }, [verification.open])

    useEffect(() => {
        const timer = setInterval(() => {
            setContactCooldowns((prev) => ({
                email: {
                    ...prev.email,
                    seconds: Math.max(0, prev.email.seconds - 1)
                },
                phone: {
                    ...prev.phone,
                    seconds: Math.max(0, prev.phone.seconds - 1)
                }
            }))
        }, 1000)

        return () => clearInterval(timer)
    }, [])

    const initProfile = async () => {
        const params = {
            access: 'auth',
            method: API.PROFILE.type,
            url: API.PROFILE.url,
            reqBody: {}
        }
        const response = await Api(params)
        if (response) {
            const profileData = response.data || {}
            setProfile(profileData)
            setProfileImage(profileData.image_profile)
            setProfileForm({
                firstname: profileData.firstname || '',
                lastname: profileData.lastname || '',
                image_profile: profileData.image_profile || '',
                email: profileData.email || '',
                phone: profileData.phone || ''
            })
            setContactCooldowns({
                email: {
                    seconds: getVerificationCooldownSeconds(profileData.contact_verification_cooldown?.email),
                    target: profileData.contact_verification_cooldown?.email?.target || ''
                },
                phone: {
                    seconds: getVerificationCooldownSeconds(profileData.contact_verification_cooldown?.phone),
                    target: profileData.contact_verification_cooldown?.phone?.target || ''
                }
            })
        }
    }

    const initAddress = async () => {
        const params = {
            access: 'auth',
            method: API.ADDRESS.type,
            url: API.ADDRESS.url,
            reqBody: {}
        }
        try {
            const response = await Api(params)
            if (response.status) {
                setAddress(response.data)
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error(error.message)
        }
    }

    const handleLogout = async () => {
        await clearSession()
        navigate('/auth/login')
    }

    const handleProfileInputChange = (field, value) => {
        if (field === 'email' && isEmailVerified) return
        if (field === 'phone' && isPhoneVerified) return

        if (field === 'firstname' && value.trim()) {
            setFirstnameError('')
        }

        setProfileForm((prev) => ({
            ...prev,
            [field]: value
        }))

        if (field === 'image_profile') {
            setProfileImage(value)
        }
    }

    const isEmailVerified = ['1', 1, true, 'true'].includes(profile?.verified_email)
    const isPhoneVerified = ['1', 1, true, 'true'].includes(profile?.verified_phone)
    const emailChanged = profileForm.email.trim().toLowerCase() !== `${profile?.email || ''}`.trim().toLowerCase()
    const phoneChanged = profileForm.phone.trim() !== `${profile?.phone || ''}`.trim()

    const isTimeoutResponse = (response) => (
        Boolean(response?.isTimeout) ||
        response?.code === 'ECONNABORTED' ||
        `${response?.message || ''}`.toLowerCase().includes('timeout')
    )

    const getVerificationCooldownSeconds = (response, fallback = 0) => {
        const parsed = Number(response?.data?.expires_in_seconds ?? response?.expires_in_seconds)
        if (Number.isFinite(parsed)) return Math.max(0, Math.ceil(parsed))
        return fallback
    }

    const formatCooldown = (seconds) => {
        const safeSeconds = Math.max(0, Number(seconds) || 0)
        const minutes = Math.floor(safeSeconds / 60)
        const remainingSeconds = safeSeconds % 60

        if (minutes <= 0) return `${remainingSeconds} detik`
        return `${minutes}:${String(remainingSeconds).padStart(2, '0')}`
    }

    const setContactCooldown = (type, seconds, target) => {
        setContactCooldowns((prev) => ({
            ...prev,
            [type]: {
                seconds: Math.max(0, Number(seconds) || 0),
                target: target || prev[type]?.target || ''
            }
        }))
    }

    const openVerificationModal = ({ type, target, message = '', messageType = '', cooldownSeconds = 0 }) => {
        setVerification({
            open: true,
            type,
            target,
            token: '',
            loading: false,
            error: '',
            message,
            messageType,
            cooldownSeconds
        })
    }

    const handleSaveBasicProfile = async () => {
        if (!profileForm.firstname.trim()) {
            setFirstnameError('Nama depan harus diisi')
            return
        }

        setFirstnameError('')
        setProfileSaving(true)

        const params = {
            access: 'auth',
            method: API.PROFILE_UPDATE.type,
            url: API.PROFILE_UPDATE.url,
            reqBody: {
                firstname: profileForm.firstname,
                lastname: profileForm.lastname
            }
        }

        try {
            const response = await Api(params)
            if (response?.status) {
                toast.success('Profil berhasil diperbarui')
                await initProfile()
            } else {
                toast.error(response?.message || 'Gagal memperbarui profil')
            }
        } catch (error) {
            toast.error(error?.message || 'Gagal memperbarui profil')
        } finally {
            setProfileSaving(false)
        }
    }

    const handlePhotoSelected = async (event) => {
        const file = event.target.files?.[0]
        event.target.value = ''

        if (!file) return

        if (!file.type.startsWith('image/')) {
            toast.error('File harus berupa gambar')
            return
        }

        const formData = new FormData()
        formData.append('photo', file)
        setPhotoUploading(true)

        const params = {
            access: 'auth',
            method: API.PROFILE_PHOTO_UPLOAD.type,
            url: API.PROFILE_PHOTO_UPLOAD.url,
            reqBody: formData
        }

        try {
            const response = await Api(params)
            if (response?.status) {
                const imageProfile = response?.data?.image_profile
                toast.success('Foto profil berhasil diupload')
                if (imageProfile) {
                    setProfileImage(imageProfile)
                    setProfileForm((prev) => ({
                        ...prev,
                        image_profile: imageProfile
                    }))
                }
                await initProfile()
            } else {
                toast.error(response?.message || 'Gagal upload foto profil')
            }
        } catch (error) {
            toast.error(error?.message || 'Gagal upload foto profil')
        } finally {
            setPhotoUploading(false)
        }
    }

    const requestContactVerification = async (type) => {
        const isEmail = type === 'email'
        if (isEmail && isEmailVerified) {
            toast.info('Email sudah terverifikasi')
            return
        }
        if (!isEmail && isPhoneVerified) {
            toast.info('Nomor telepon sudah terverifikasi')
            return
        }

        const target = isEmail ? profileForm.email.trim().toLowerCase() : profileForm.phone.trim()

        if (!target) {
            toast.error(isEmail ? 'Email wajib diisi' : 'Nomor telepon wajib diisi')
            return
        }

        const activeCooldown = contactCooldowns[type]?.seconds || 0
        if (activeCooldown > 0) {
            const activeTarget = contactCooldowns[type]?.target || target
            toast.info(`Kirim ulang kode tersedia dalam ${formatCooldown(activeCooldown)}`)
            openVerificationModal({
                type,
                target: activeTarget,
                message: `Kode sebelumnya masih aktif. Kirim ulang tersedia dalam ${formatCooldown(activeCooldown)}.`,
                messageType: 'success',
                cooldownSeconds: activeCooldown
            })
            return
        }

        setContactLoading(type)

        const params = {
            access: 'auth',
            method: isEmail ? API.PROFILE_EMAIL_REQUEST.type : API.PROFILE_PHONE_REQUEST.type,
            url: isEmail ? API.PROFILE_EMAIL_REQUEST.url : API.PROFILE_PHONE_REQUEST.url,
            reqBody: isEmail ? { email: target } : { phone: target }
        }

        try {
            const response = await Api(params)
            if (response?.status) {
                if (response?.already_verified || (isEmail && !emailChanged && isEmailVerified) || (!isEmail && !phoneChanged && isPhoneVerified)) {
                    toast.success(response.message || 'Kontak sudah terverifikasi')
                    await initProfile()
                    return
                }

                const cooldownSeconds = getVerificationCooldownSeconds(response)
                if (response?.already_active) {
                    const activeTarget = response?.data?.target || target
                    setContactCooldown(type, cooldownSeconds, activeTarget)
                    toast.info(response.message || 'Token verifikasi masih aktif')
                    openVerificationModal({
                        type,
                        target: activeTarget,
                        message: `Kode sebelumnya masih aktif. Kirim ulang tersedia dalam ${formatCooldown(cooldownSeconds)}.`,
                        messageType: 'success',
                        cooldownSeconds
                    })
                    return
                }

                toast.success(response.message || 'Token verifikasi telah dikirim')
                setContactCooldown(type, cooldownSeconds, target)
                openVerificationModal({
                    type,
                    target,
                    cooldownSeconds
                })
            } else if (isTimeoutResponse(response)) {
                toast.info('Kode verifikasi sedang diproses. Silakan cek email atau WhatsApp Anda.')
                openVerificationModal({
                    type,
                    target,
                    message: 'Jika kode sudah diterima, masukkan 6 digit kode di sini. Jika belum, gunakan kirim ulang.',
                    messageType: 'success',
                    cooldownSeconds: 300
                })
                setContactCooldown(type, 300, target)
            } else {
                toast.error(response?.message || 'Gagal mengirim token verifikasi')
            }
        } catch (error) {
            if (isTimeoutResponse(error)) {
                toast.info('Kode verifikasi sedang diproses. Silakan cek email atau WhatsApp Anda.')
                openVerificationModal({
                    type,
                    target,
                    message: 'Jika kode sudah diterima, masukkan 6 digit kode di sini. Jika belum, gunakan kirim ulang.',
                    messageType: 'success',
                    cooldownSeconds: 300
                })
                setContactCooldown(type, 300, target)
            } else {
                toast.error(error?.message || 'Gagal mengirim token verifikasi')
            }
        } finally {
            setContactLoading('')
        }
    }

    const closeVerificationModal = () => {
        if (verification.loading) return

        setVerification({
            open: false,
            type: '',
            target: '',
            token: '',
            loading: false,
            error: '',
            message: '',
            messageType: '',
            cooldownSeconds: 0
        })
    }

    const updateVerificationToken = (value) => {
        const token = value.replace(/\D/g, '').slice(0, 6)

        setVerification((prev) => ({
            ...prev,
            token,
            error: '',
            message: '',
            messageType: ''
        }))
    }

    const focusVerificationInput = (selectValue = false) => {
        setTimeout(() => {
            verificationInputRef.current?.focus()
            if (selectValue) {
                verificationInputRef.current?.select()
            }
        }, 50)
    }

    const handleEditVerificationToken = () => {
        setVerification((prev) => ({
            ...prev,
            token: '',
            error: '',
            message: '',
            messageType: ''
        }))
        focusVerificationInput()
    }

    const handleTokenBoxClick = (index) => {
        setVerification((prev) => ({
            ...prev,
            token: index < prev.token.length ? prev.token.slice(0, index) : prev.token,
            error: '',
            message: '',
            messageType: ''
        }))
        focusVerificationInput()
    }

    const handleResendVerification = () => {
        if (verification.loading || contactLoading === verification.type) return
        if (verification.cooldownSeconds > 0) {
            toast.info(`Kirim ulang kode tersedia dalam ${formatCooldown(verification.cooldownSeconds)}`)
            return
        }

        setVerification((prev) => ({
            ...prev,
            token: '',
            error: '',
            message: '',
            messageType: ''
        }))
        requestContactVerification(verification.type)
    }

    const handleVerifyContact = async () => {
        if (verification.token.length !== 6) {
            setVerification((prev) => ({
                ...prev,
                error: 'Token harus 6 digit'
            }))
            focusVerificationInput()
            return
        }

        const isEmail = verification.type === 'email'
        setVerification((prev) => ({
            ...prev,
            loading: true,
            error: '',
            message: '',
            messageType: ''
        }))

        const params = {
            access: 'auth',
            method: isEmail ? API.PROFILE_EMAIL_VERIFY.type : API.PROFILE_PHONE_VERIFY.type,
            url: isEmail ? API.PROFILE_EMAIL_VERIFY.url : API.PROFILE_PHONE_VERIFY.url,
            reqBody: isEmail
                ? { email: verification.target, token: verification.token }
                : { phone: verification.target, token: verification.token }
        }

        try {
            const response = await Api(params)
            if (response?.status) {
                setContactCooldown(verification.type, 0, verification.target)
                setVerification((prev) => ({
                    ...prev,
                    message: isEmail ? 'Email berhasil diverifikasi' : 'Nomor telepon berhasil diverifikasi',
                    messageType: 'success'
                }))
                await initProfile()
                setTimeout(() => {
                    setVerification({
                        open: false,
                        type: '',
                        target: '',
                        token: '',
                        loading: false,
                        error: '',
                        message: '',
                        messageType: '',
                        cooldownSeconds: 0
                    })
                }, 700)
            } else {
                setVerification((prev) => ({
                    ...prev,
                    message: response?.message || 'Token tidak valid',
                    messageType: 'error'
                }))
                focusVerificationInput(true)
            }
        } catch (error) {
            setVerification((prev) => ({
                ...prev,
                message: error?.message || 'Gagal memverifikasi token',
                messageType: 'error'
            }))
            focusVerificationInput(true)
        } finally {
            setVerification((prev) => ({
                ...prev,
                loading: false
            }))
        }
    }

    const handleDeleteAddress = (id) => {
        Swal.fire({
            title: 'Yakin akan hapus alamat?',
            text: 'Data alamat yang dihapus tidak bisa dikembalikan.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            customClass: {
                title: 'text-base',
                confirmButton:
                    'bg-red-600 hover:bg-red-700 text-white font-normal text-sm py-2 px-4 rounded-md',
                cancelButton:
                    'bg-gray-500 hover:bg-gray-600 text-white font-normal text-sm py-2 px-4 rounded-md'
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const params = {
                    access: 'auth',
                    method: API.ADDRESS_DELETE.type,
                    url: API.ADDRESS_DELETE.url,
                    reqBody: {
                        address_id: id
                    }
                }

                try {
                    const response = await Api(params)
                    if (response.status) {
                        toast(response.message)
                        initAddress()
                    } else {
                        toast.error(response.message)
                    }
                } catch (error) {
                    toast.error(error.message)
                }
            }
        })
    }

    const LoadingSkeleton = () => (
        <div className="animate-pulse space-y-4">
            <div className="h-24 rounded-lg bg-gray-200" />
            <div className="h-16 rounded-lg bg-gray-200" />
            <div className="space-y-3">
                <div className="h-4 w-1/3 rounded bg-gray-200" />
                <div className="h-24 rounded-lg bg-gray-200" />
                <div className="h-24 rounded-lg bg-gray-200" />
            </div>
        </div>
    )

    if (!profile) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="mx-auto max-w-sm px-4 py-5">
                    <LoadingSkeleton />
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-[#faf8f4] text-slate-800">
            <ToastContainer autoClose={1000} />
            <div className="mx-auto max-w-sm overflow-hidden pb-24">
                {/* Hero Section */}
                <section
                    className="relative h-[250px] overflow-hidden bg-cover bg-top px-6 pt-8"
                    style={{
                        backgroundImage: `linear-gradient(90deg, rgba(255, 249, 238, 0.98) 0%, rgba(255, 249, 238, 0.9) 49%, rgba(255, 249, 238, 0.15) 100%), url(${HomeBakeryBackground})`,
                    }}
                >
                    <div className="relative max-w-[205px]">
                        <p className="text-[10px] font-bold uppercase tracking-[0.22em]" style={{ color: primaryColor || '#a34b3f' }}>
                            Selamat datang
                        </p>
                        <h1 className="mt-1 text-[30px] font-extrabold leading-tight tracking-tight text-slate-800">
                            {memberName} <span aria-hidden="true">👋</span>
                        </h1>
                        <p className="mt-1 text-xs leading-relaxed text-slate-500">
                            Terima kasih sudah menjadi bagian dari kami.
                        </p>
                    </div>
                </section>

                {/* Points Card */}
                <section className="relative z-10 mx-4 -mt-[100px] h-[124px] overflow-hidden rounded-2xl border border-amber-200/70 shadow-[0_12px_28px_rgba(129,95,45,0.2)]">
                    <img
                        src={GoldenCrownRewardCard}
                        alt=""
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="relative flex h-full items-center px-7">
                        <div className="text-white drop-shadow-sm">
                            <p className="text-sm font-semibold">Total Poin Anda</p>
                            <p className="mt-1 text-[42px] font-extrabold leading-none tracking-tight">
                                {Intl.NumberFormat('en-ID').format(memberPoints)}
                            </p>
                            <p className="mt-1 text-xs font-semibold">poin</p>
                        </div>
                    </div>
                </section>

                {/* Quick Actions */}
                <section className="mt-5 px-4">
                    <h2 className="text-base font-extrabold text-slate-800">Akses Cepat</h2>
                    <p className="mt-0.5 text-xs text-slate-500">Pilih menu yang ingin Anda akses</p>
                    <div className="mt-3 grid gap-3">
                        {quickActions.map((action) => (
                            <button
                                key={action.id}
                                type="button"
                                className="group relative overflow-hidden rounded-xl border border-white bg-white p-3 text-left shadow-[0_7px_18px_rgba(30,41,59,0.08)] transition duration-200 hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
                                style={{ '--tw-ring-color': primaryColor || '#a34b3f' }}
                                onClick={() => navigate(action.link)}
                            >
                                <div className={`absolute inset-0 bg-gradient-to-br ${action.id === 1 ? 'from-indigo-50/80 to-white' : 'from-green-50/80 to-white'}`} />
                                <div className="relative">
                                    <div className={`grid h-12 w-12 place-items-center rounded-xl bg-gradient-to-br ${action.color} text-white shadow-sm transition-transform duration-200 group-hover:scale-105`}>
                                        {action.icon}
                                    </div>
                                    <p className="mt-3 text-sm font-bold text-slate-700">{action.title}</p>
                                    <p className="text-xs text-slate-500">{action.subtitle}</p>
                                    <span className={`absolute bottom-0 right-0 grid h-5 w-5 place-items-center rounded-full ${action.id === 1 ? 'bg-indigo-100 text-indigo-500' : 'bg-green-100 text-green-600'}`}>
                                        <AiOutlineRight className="text-xs" />
                                    </span>
                                </div>
                            </button>
                        ))}
                    </div>
                </section>

                {/* Vouchers */}
                <section className="mt-6 px-4">
                    {/* <div className="mb-3 flex items-center justify-between">
                        <div>
                            <h2 className="text-base font-extrabold text-slate-800">Voucher Saya</h2>
                            <p className="mt-0.5 text-xs text-slate-500">Koleksi voucher Anda</p>
                        </div>
                        <div className="grid h-9 w-9 place-items-center rounded-xl bg-[#f8e6e0] text-[#a34b3f]">
                            <AiOutlineGift className="text-lg" />
                        </div>
                    </div> */}

                    {/* {profile?.member_voucher?.length === 0 ? (
                        <Card className="border border-dashed border-slate-200 bg-white shadow-none">
                            <Card.Body className="p-6 text-center">
                                <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-slate-50">
                                    <AiOutlineGift className="text-xl text-slate-400" />
                                </div>
                                <p className="mt-2 text-sm font-semibold text-slate-600">Belum ada voucher</p>
                                <p className="mt-1 text-xs text-slate-400">Yuk mulai kumpulkan poin!</p>
                            </Card.Body>
                        </Card>
                    ) : (
                        <div className="space-y-3">
                            {profile?.member_voucher?.map((mv, i) => (
                                <Card key={i} className="border border-slate-100 bg-white shadow-sm">
                                    <Card.Body className="p-3">
                                        <div className="flex items-center gap-3">
                                            <img
                                                src={mv?.voucher?.voucher_image === null ? DefaultVoucher : (mv?.voucher?.voucher_image || DefaultVoucher)}
                                                alt="Voucher"
                                                className="h-12 w-12 rounded-lg object-cover"
                                            />
                                            <div className="min-w-0 flex-1">
                                                <h3 className="truncate text-sm font-semibold text-slate-700">
                                                    {mv?.voucher?.voucher_name || mv?.voucher?.name || `Voucher #${i + 1}`}
                                                </h3>
                                                <p className="mt-0.5 truncate text-xs text-slate-500">
                                                    {mv?.voucher?.voucher_description || mv?.voucher?.description || 'Deskripsi voucher'}
                                                </p>
                                                <p className="mt-1 text-xs font-semibold text-[#a34b3f]">{formatVoucherDiscount(mv)}</p>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    )} */}
                </section>

                <div className="px-4 mt-6 flex flex-col space-y-4">
                    <Card className="rounded-xl border border-slate-200 bg-white shadow-sm">
                        <Card.Body className="space-y-4 p-4">
                            <div className="flex items-center gap-2">
                                <AiOutlineUser className="text-slate-600" />
                                <h3 className="text-sm font-semibold text-slate-800">Edit Profil</h3>
                            </div>

                            <div className="grid grid-cols-1 gap-3">
                                <label className="space-y-1">
                                    <span className="text-xs font-medium text-slate-600">Nama Depan</span>
                                    <input
                                        className="input input-bordered input-sm w-full rounded-md"
                                        value={profileForm.firstname}
                                        onChange={(e) => handleProfileInputChange('firstname', e.target.value)}
                                    />
                                    {firstnameError && (
                                        <span className="block text-xs italic text-red-600">{firstnameError}</span>
                                    )}
                                </label>

                                <label className="space-y-1">
                                    <span className="text-xs font-medium text-slate-600">Nama Belakang</span>
                                    <input
                                        className="input input-bordered input-sm w-full rounded-md"
                                        value={profileForm.lastname}
                                        onChange={(e) => handleProfileInputChange('lastname', e.target.value)}
                                    />
                                </label>

                                <div className="space-y-2">
                                    <span className="text-xs font-medium text-slate-600">Foto Profil</span>
                                    <div className="flex items-center gap-3 mb-2">
                                        <img
                                            src={profileImage || ProfilUnknow}
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null
                                                currentTarget.src = ProfilUnknow
                                            }}
                                            alt="profile"
                                            className="h-14 w-14 rounded-full border border-slate-200 object-cover"
                                        />
                                        <div className="flex flex-col gap-2 sm:flex-row">
                                            <Button
                                                size="sm"
                                                className="rounded-md border border-slate-300 bg-white text-xs font-normal text-white hover:bg-slate-100"
                                                onClick={() => fileInputRef.current?.click()}
                                                disabled={photoUploading}
                                            >
                                                {photoUploading ? (
                                                    <AiOutlineLoading3Quarters className="mr-1 animate-spin text-sm" />
                                                ) : (
                                                    <AiOutlinePlus className="mr-1 text-sm" />
                                                )}
                                                Upload File
                                            </Button>
                                            <Button
                                                size="sm"
                                                className="rounded-md border border-slate-300 bg-white text-xs font-normal text-white hover:bg-slate-100"
                                                onClick={() => cameraInputRef.current?.click()}
                                                disabled={photoUploading}
                                            >
                                                {photoUploading ? (
                                                    <AiOutlineLoading3Quarters className="mr-1 animate-spin text-sm" />
                                                ) : (
                                                    <AiOutlineCamera className="mr-1 text-sm" />
                                                )}
                                                Kamera
                                            </Button>
                                        </div>
                                    </div>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        accept="image/*"
                                        className="hidden"
                                        onChange={handlePhotoSelected}
                                    />
                                    <input
                                        ref={cameraInputRef}
                                        type="file"
                                        accept="image/*"
                                        capture="user"
                                        className="hidden"
                                        onChange={handlePhotoSelected}
                                    />
                                </div>

                                {/* <Button
                                    size="sm"
                                    className="rounded-md border-none bg-blue-600 text-xs font-normal text-white hover:bg-blue-700 mt-2"
                                    onClick={handleSaveBasicProfile}
                                    disabled={profileSaving}
                                >
                                    {profileSaving ? (
                                        <AiOutlineLoading3Quarters className="mr-1 animate-spin text-sm" />
                                    ) : (
                                        <AiOutlineSave className="mr-1 text-sm" />
                                    )}
                                    Simpan Nama
                                </Button> */}
                            </div>

                            <div className="border-t border-slate-100 pt-4">
                                <label className="space-y-1">
                                    <span className="text-xs font-medium text-slate-600">Email</span>
                                    <div className="flex gap-2">
                                        <input
                                            className={`input input-bordered input-sm min-w-0 flex-1 rounded-md ${
                                                isEmailVerified ? 'bg-slate-50 text-slate-500' : ''
                                            }`}
                                            value={profileForm.email}
                                            disabled={verification.open || isEmailVerified}
                                            readOnly={isEmailVerified}
                                            onChange={(e) => handleProfileInputChange('email', e.target.value)}
                                            placeholder="email@example.com"
                                        />
                                        <Button
                                            size="sm"
                                            className={`rounded-md border-none text-xs font-normal text-white ${
                                                isEmailVerified
                                                    ? 'bg-green-500 hover:bg-green-500'
                                                    : 'bg-slate-700 hover:bg-slate-800'
                                            }`}
                                            onClick={() => requestContactVerification('email')}
                                            disabled={contactLoading === 'email' || isEmailVerified}
                                        >
                                            {contactLoading === 'email' ? (
                                                <AiOutlineLoading3Quarters className="mr-1 animate-spin text-sm" />
                                            ) : isEmailVerified ? (
                                                <AiOutlineCheckCircle className="mr-1 text-sm" />
                                            ) : (
                                                <AiOutlineMail className="mr-1 text-sm" />
                                            )}
                                            {isEmailVerified
                                                ? 'Verified'
                                                : contactCooldowns.email.seconds > 0
                                                ? 'Masukkan kode'
                                                : 'Verifikasi'}
                                        </Button>
                                    </div>
                                </label>
                                <div className="mt-1 flex items-center gap-1 text-[11px] text-slate-500">
                                    {isEmailVerified ? (
                                        <>
                                            <AiOutlineCheckCircle className="text-green-600" />
                                            Email sudah terverifikasi dan tidak bisa diubah
                                        </>
                                    ) : (
                                        <>
                                            <AiOutlineExclamationCircle className="text-amber-600" />
                                            Email baru harus diverifikasi dengan token
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="border-t border-slate-100 pt-4">
                                <label className="space-y-1">
                                    <span className="text-xs font-medium text-slate-600">Nomor Telepon</span>
                                    <div className="flex gap-2">
                                        <input
                                            className={`input input-bordered input-sm min-w-0 flex-1 rounded-md ${
                                                isPhoneVerified ? 'bg-slate-50 text-slate-500' : ''
                                            }`}
                                            value={profileForm.phone}
                                            disabled={verification.open || isPhoneVerified}
                                            readOnly={isPhoneVerified}
                                            onChange={(e) => handleProfileInputChange('phone', e.target.value)}
                                            placeholder="08xxxxxxxxxx"
                                        />
                                        <Button
                                            size="sm"
                                            className={`rounded-md border-none text-xs font-normal text-white ${
                                                isPhoneVerified
                                                    ? 'bg-green-500 hover:bg-green-500'
                                                    : 'bg-slate-700 hover:bg-slate-800'
                                            }`}
                                            onClick={() => requestContactVerification('phone')}
                                            disabled={contactLoading === 'phone' || isPhoneVerified}
                                        >
                                            {contactLoading === 'phone' ? (
                                                <AiOutlineLoading3Quarters className="mr-1 animate-spin text-sm" />
                                            ) : isPhoneVerified ? (
                                                <AiOutlineCheckCircle className="mr-1 text-sm" />
                                            ) : (
                                                <AiOutlinePhone className="mr-1 text-sm" />
                                            )}
                                            {isPhoneVerified
                                                ? 'Verified'
                                                : contactCooldowns.phone.seconds > 0
                                                ? 'Masukkan kode'
                                                : 'Verifikasi'}
                                        </Button>
                                    </div>
                                </label>
                                <div className="mt-1 flex items-center gap-1 text-[11px] text-slate-500">
                                    {isPhoneVerified ? (
                                        <>
                                            <AiOutlineCheckCircle className="text-green-600" />
                                            Nomor telepon sudah terverifikasi dan tidak bisa diubah
                                        </>
                                    ) : (
                                        <>
                                            <AiOutlineExclamationCircle className="text-amber-600" />
                                            Nomor baru harus diverifikasi lewat WhatsApp
                                        </>
                                    )}
                                </div>
                            </div>
                        </Card.Body>
                    </Card>

                    <div className="space-y-3">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <AiOutlineEnvironment className="text-slate-600" />
                                <h3 className="text-sm font-semibold text-slate-800">Daftar Alamat</h3>
                            </div>
                            <Button
                                size="sm"
                                className="rounded-md border-none bg-green-500 text-xs font-normal text-white hover:bg-green-600"
                                onClick={() => navigate('/profile/address/new')}
                            >
                                <AiOutlinePlus className="mr-1 text-sm" />
                                Tambah
                            </Button>
                        </div>

                        {address.length === 0 ? (
                            <Card className="rounded-xl border border-dashed border-slate-300 bg-white shadow-sm">
                                <Card.Body className="py-7 text-center">
                                    <FaMapMarkerAlt className="mx-auto mb-2 text-3xl text-slate-400" />
                                    <p className="text-sm text-slate-500">Belum ada alamat tersimpan</p>
                                    <p className="mt-1 text-xs text-slate-400">
                                        Tambahkan alamat untuk memudahkan pengiriman
                                    </p>
                                </Card.Body>
                            </Card>
                        ) : (
                            <div className="space-y-3">
                                {address.map((item, index) => {
                                    const coordinate = getAddressCoordinatePair(item)
                                    const latitude = normalizeCoordinate(coordinate.latitude)
                                    const longitude = normalizeCoordinate(coordinate.longitude)
                                    const hasCoordinate = latitude && longitude

                                    return (
                                        <Card
                                            key={index}
                                            className="rounded-xl border border-slate-200 bg-white shadow-sm"
                                        >
                                            <Card.Body className="p-4">
                                                <div className="flex items-start justify-between gap-3">
                                                    <div className="min-w-0 flex-1">
                                                        <div className="mb-1 flex items-center gap-2">
                                                            <FaMapMarkerAlt className="text-red-500" />
                                                            <h4 className="truncate text-sm font-semibold text-slate-800">
                                                                {item.address_name}
                                                            </h4>
                                                        </div>
                                                        <p className="mb-1 text-xs text-slate-600">
                                                            {item.full_address}
                                                        </p>
                                                        <p className="mt-1 text-xs text-slate-500">
                                                            Koordinat:{' '}
                                                            {hasCoordinate ? `${latitude}, ${longitude}` : '-'}
                                                        </p>
                                                    </div>
                                                    <div className="flex gap-2">
                                                        <Button
                                                            size="sm"
                                                            className="h-9 w-9 min-h-0 rounded-md border-none bg-blue-500 p-0 text-white hover:bg-blue-600"
                                                            onClick={() =>
                                                                navigate(
                                                                    `/profile/address/${item.address_id}/edit`
                                                                )
                                                            }
                                                            aria-label="Edit alamat"
                                                        >
                                                            <AiOutlineEdit className="text-sm" />
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            className="h-9 w-9 min-h-0 rounded-md border-none bg-red-500 p-0 text-white hover:bg-red-600"
                                                            onClick={() =>
                                                                handleDeleteAddress(item.address_id)
                                                            }
                                                            aria-label="Hapus alamat"
                                                        >
                                                            <AiOutlineDelete className="text-sm" />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    )
                                })}
                            </div>
                        )}
                    </div>

                    <Button
                        size="sm"
                        className="rounded-md border-none bg-blue-600 text-xs font-normal text-white hover:bg-blue-700 mt-2"
                        onClick={handleSaveBasicProfile}
                        disabled={profileSaving}
                    >
                        {profileSaving ? (
                            <AiOutlineLoading3Quarters className="mr-1 animate-spin text-sm" />
                        ) : (
                            <AiOutlineSave className="mr-1 text-sm" />
                        )}
                        Simpan Profil
                    </Button>

                    <Button
                        onClick={handleLogout}
                        aria-label="Logout"
                        color="error"
                        className="mt-4 w-full text-white"
                    >
                        <AiOutlineLogout className="mr-2 text-xl" />
                        Logout
                    </Button>
                </div>
            </div>

            <Modal.Legacy
                open={verification.open}
                onClickBackdrop={closeVerificationModal}
                className="mx-4 max-w-md animate-in fade-in duration-200"
            >
                <Modal.Header className="rounded-t-lg bg-gradient-to-r from-blue-500 to-purple-600 text-white">
                    <div className="flex items-center gap-3">
                        <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white bg-opacity-20">
                            <AiOutlineLock className="text-lg text-white" />
                        </div>
                        <div>
                            <h3 className="text-lg font-bold">
                                Verifikasi {verification.type === 'email' ? 'Email' : 'Nomor HP'}
                            </h3>
                            <p className="text-sm text-blue-100">Kode verifikasi 6 digit</p>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="px-6 py-6">
                    <div className="mb-7 text-center">
                        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-blue-100 to-purple-100 shadow-lg">
                            {verification.type === 'email' ? (
                                <AiOutlineMail className="text-2xl text-blue-600" />
                            ) : (
                                <AiOutlinePhone className="text-2xl text-blue-600" />
                            )}
                        </div>
                        <h4 className="mb-2 font-semibold text-gray-800">
                            Masukkan Kode Verifikasi
                        </h4>
                        <p className="mb-2 text-sm text-gray-600">
                            Kode telah dikirim ke:
                        </p>
                        <div className="inline-flex max-w-full items-center rounded-full border border-blue-200 bg-blue-50 px-3 py-1">
                            {verification.type === 'email' ? (
                                <AiOutlineMail className="mr-2 flex-shrink-0 text-blue-600" />
                            ) : (
                                <AiOutlinePhone className="mr-2 flex-shrink-0 text-blue-600" />
                            )}
                            <span className="break-all font-mono text-sm font-semibold text-blue-800">
                                {verification.target}
                            </span>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div className="space-y-4">
                            <label className="block text-center">
                                <span className="font-medium text-gray-700">
                                    Masukkan 6 digit kode
                                </span>
                            </label>

                            <input
                                ref={verificationInputRef}
                                type="text"
                                className="sr-only"
                                value={verification.token}
                                onChange={(e) => updateVerificationToken(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && verification.token.length === 6) {
                                        handleVerifyContact()
                                    }
                                }}
                                onPaste={(e) => {
                                    e.preventDefault()
                                    updateVerificationToken(e.clipboardData.getData('text'))
                                }}
                                maxLength={6}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                autoComplete="one-time-code"
                            />

                            <div className="flex justify-center gap-2">
                                {[...Array(6)].map((_, index) => {
                                    const hasValue = index < verification.token.length
                                    const hasError = verification.error || verification.messageType === 'error'

                                    return (
                                        <button
                                            key={index}
                                            type="button"
                                            onClick={() => handleTokenBoxClick(index)}
                                            className={`flex h-12 w-11 items-center justify-center rounded-2xl border-2 font-mono text-xl font-bold transition-all duration-200 sm:h-14 sm:w-14 ${
                                                hasValue
                                                    ? 'scale-105 border-blue-500 bg-gradient-to-br from-blue-500 to-blue-600 text-white shadow-lg'
                                                    : hasError
                                                        ? 'border-red-400 bg-red-50 text-red-600'
                                                        : 'border-gray-300 bg-white text-gray-800 hover:border-blue-400 hover:bg-blue-50'
                                            }`}
                                        >
                                            {verification.token[index] || (
                                                <span className="h-2 w-2 rounded-full bg-gray-300" />
                                            )}
                                        </button>
                                    )
                                })}
                            </div>

                            {verification.error && (
                                <div className="mt-3 flex items-center justify-center text-sm text-red-600">
                                    <AiOutlineExclamationCircle className="mr-2" />
                                    {verification.error}
                                </div>
                            )}

                            <div className="text-center">
                                <div className="inline-flex items-center gap-2 text-sm">
                                    <div
                                        className={`h-2 w-2 rounded-full transition-colors duration-300 ${
                                            verification.token.length === 6 ? 'bg-green-500' : 'bg-gray-400'
                                        }`}
                                    />
                                    <span
                                        className={`font-medium transition-colors duration-300 ${
                                            verification.token.length === 6 ? 'text-green-600' : 'text-gray-500'
                                        }`}
                                    >
                                        {verification.token.length === 6
                                            ? 'Kode lengkap'
                                            : `${verification.token.length} dari 6 digit`}
                                    </span>
                                </div>
                            </div>

                            {verification.token.length > 0 && (
                                <div className="text-center">
                                    <button
                                        type="button"
                                        className="inline-flex items-center text-sm font-medium text-blue-600 underline hover:text-blue-800 disabled:text-gray-400"
                                        onClick={handleEditVerificationToken}
                                        disabled={verification.loading}
                                    >
                                        <AiOutlineEdit className="mr-1" />
                                        Ubah kode
                                    </button>
                                </div>
                            )}
                        </div>

                        {verification.message && (
                            <div
                                className={`rounded-xl border-2 p-4 text-center transition-all duration-300 ${
                                    verification.messageType === 'success'
                                        ? 'border-green-200 bg-green-50 text-green-700'
                                        : 'border-red-200 bg-red-50 text-red-700'
                                }`}
                            >
                                <div className="flex items-center justify-center">
                                    {verification.messageType === 'success' ? (
                                        <AiOutlineCheckCircle className="mr-2 text-xl" />
                                    ) : (
                                        <AiOutlineExclamationCircle className="mr-2 text-xl" />
                                    )}
                                    <span className="font-medium">{verification.message}</span>
                                </div>
                            </div>
                        )}

                        <div className="text-center">
                            <p className="mb-2 text-sm text-gray-500">Tidak menerima kode?</p>
                            <button
                                type="button"
                                className="text-sm font-medium text-blue-600 underline hover:text-blue-800 disabled:text-gray-400"
                                onClick={handleResendVerification}
                                disabled={verification.loading || contactLoading === verification.type || verification.cooldownSeconds > 0}
                            >
                                {contactLoading === verification.type
                                    ? 'Mengirim ulang...'
                                    : verification.cooldownSeconds > 0
                                    ? `Kirim ulang (${formatCooldown(verification.cooldownSeconds)})`
                                    : 'Kirim ulang kode'}
                            </button>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Actions className="flex justify-end gap-3 rounded-b-lg bg-gray-50 px-6 py-4">
                    <Button
                        variant="outline"
                        onClick={closeVerificationModal}
                        disabled={verification.loading}
                        className="border-gray-300 px-6 py-2 hover:bg-gray-100"
                    >
                        Batal
                    </Button>
                    <Button
                        onClick={handleVerifyContact}
                        disabled={verification.loading || verification.token.length !== 6}
                        className={`rounded-lg px-7 py-3 font-semibold transition-all duration-200 ${
                            verification.token.length === 6 && !verification.loading
                                ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg hover:from-blue-600 hover:to-purple-700 hover:shadow-xl'
                                : 'cursor-not-allowed bg-gray-300 text-gray-500'
                        }`}
                    >
                        {verification.loading ? (
                            <div className="flex items-center">
                                <AiOutlineLoading3Quarters className="mr-2 animate-spin" />
                                Memverifikasi...
                            </div>
                        ) : verification.token.length === 6 ? (
                            <div className="flex items-center">
                                <AiOutlineCheckCircle className="mr-2" />
                                Verifikasi
                            </div>
                        ) : (
                            <div className="flex items-center">
                                <AiOutlineLock className="mr-2" />
                                Lengkapi Kode
                            </div>
                        )}
                    </Button>
                </Modal.Actions>
            </Modal.Legacy>

        </div>
    )
}

export default Profile
